import { createAction, createReducer } from '@reduxjs/toolkit';
import { desktopPromptModalId } from '../components/DesktopPromptModal';

export const showModal = createAction<string>('@modal/SHOW');
export const hideModal = createAction<string>('@modal/HIDE');
export const setModalPayload = createAction<{ id: string; payload?: any }>('@modal/SET_PAYLOAD');

export const initialState = {
  visible: {
    userInfoForm: false,
    optInForm: false,
    [desktopPromptModalId]: false,
  },
  payloads: {} as Record<string, any>,
};

export default createReducer(initialState, (builder) =>
  builder
    .addCase(showModal, (state, action) => ({
      ...state,
      visible: { ...state.visible, [action.payload]: true },
    }))
    .addCase(hideModal, (state, action) => ({
      ...state,
      visible: { ...state.visible, [action.payload]: false },
      payloads: { ...state.payloads, [action.payload]: undefined },
    }))
    .addCase(setModalPayload, (state, action) => ({
      ...state,
      payloads: { ...state.payloads, [action.payload.id]: action.payload.payload },
    }))
);
